





























import Vue from 'vue'
import { clone, each, filter, includes, isEqual, xor } from 'lodash-es'
import { Speciality } from 'models/med_templates/speciality'

export default Vue.extend({
    data() {
        return {
            selected: [] as number[],
            /** describes whether the dropdown is opened/closed */
            opened: false,
            selecting: false,
        }
    },
    computed: {
        specialities(): Speciality[] {
            const selectedIds = this.$store.direct.state.user.filters.specialities
            const allSpecialities = this.$store.direct.state.templates.specialities
            return selectedIds.length ?
                filter(allSpecialities, speciality => includes(selectedIds, speciality.id))
                : allSpecialities
        },
        groupedDoctors() {
            return this.$store.direct.getters.templates.groupedDoctors
        },
        /** computed showing there is at least one doctor available for selection */
        atLeastOne(): boolean {
            let atLeastOne = false
            each(this.groupedDoctors, group => {
                if (group.doctors.length) {
                    atLeastOne = true
                    return false
                }
                return
            })
            return atLeastOne
        },
        selectedDoctors: {
            get(): number[] {
                return this.$store.direct.state.user.filters.doctors
            },
            set(doctorIDs: number[]) {
                if (!isEqual(doctorIDs, this.$store.direct.state.user.filters.doctors)) {
                    this.$store.direct.dispatch.user.updateFilters({'doctors': doctorIDs})
                    this.$emit('update')
                }
            }
        },
        selectedText(): string {
            let labels: string[] = []
            each(this.selected, id => {
                const doctor = this.$store.direct.getters.templates.doctor(id)
                if (doctor)
                    labels.push(doctor.last_name)
            })
            return labels.join(", ") || "[All]"
        },
    },
    watch: {
        selectedDoctors: {
            handler: function(val: any) {
                if (!isEqual(val, this.selected))
                    this.selected = clone(val)
            },
            immediate: true
        },
        opened(val: any) {
            if (!val)
                this.selectedDoctors = this.selected
        }
    },
    methods: {
        showHandler(event: any) {
            this.opened = true
        },
        hideHandler(event: any) {
            if (this.selecting) {
                // Don't close the dropdown if we're currently selecting items
                event.preventDefault()
            }
            else {
                this.opened = false
            }
            this.selecting = false
        },
        clearSelections() {
            this.selected = []
        },
        toggleSelect(id: number) {
            this.selecting = true
            this.selected = xor(this.selected, [id])
        },
        isSelected(id: number): boolean {
            return includes(this.selected, id)
        },
    }
})
